import { createI18n } from 'vue-i18n';
import messages from './language/i18n';

// Price format: controlled by config.price_show_cents (default: show cents).
// Set price_show_cents: false in config to hide cents in currency display.
const defaultCurrencyOptions = (fractionDigits = 2) => ({
    style: 'currency',
    currencyDisplay: 'symbol',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
});

// App locale -> BCP 47 locale (for Intl number/currency formatting).
export const appLocaleToBCP47 = {
    fr: 'fr-FR',
    de: 'de-DE'
};
// App locale -> leaflet-routing-machine language (base codes only; e.g. 'es' not 'es-AR').
export const appLocaleToRoutingLanguage = {
    fr: 'fr',
    de: 'de'
};

const i18n = createI18n({
    legacy: true,
    locale: 'fr',
    fallbackLocale: 'fr',
    messages,
    silentFallbackWarn: true,
    numberFormats: {
        fr: {
            currency: {
                currency: 'EUR',
                ...defaultCurrencyOptions(2)
            }
        },
        de: {
            currency: {
                currency: 'EUR',
                ...defaultCurrencyOptions(2)
            }
        },
        'fr-FR': {
            currency: {
                currency: 'EUR',
                ...defaultCurrencyOptions(2)
            }
        },
        'de-DE': {
            currency: {
                currency: 'EUR',
                ...defaultCurrencyOptions(2)
            }
        }
    }
});

export function applyPriceFormat(showCents) {
    const fractionDigits = showCents !== false ? 2 : 0;
    const options = defaultCurrencyOptions(fractionDigits);
    const formats = [
        ['fr', 'EUR'],
        ['de', 'EUR'],
        ['fr-FR', 'EUR'],
        ['de-DE', 'EUR']
    ];
    formats.forEach(([locale, currency]) => {
        i18n.global.mergeNumberFormat(locale, {
            currency: { style: 'currency', currency, ...options }
        });
    });
}

export default i18n;
